export const NEARBY_STORES_SET = "NEARBY_STORES_SET"
export const HIGHLIGHTED_STORE_ID_SET = "HIGHLIGHTED_STORE_ID_SET"
export const PATTERN_ID_SET = "PATTERN_ID_SET"
export const CITY_ID_SET = "CITY_ID_SET"
export const CURRENT_SEARCH_CLEAR = "CURRENT_SEARCH_CLEAR"
